export default __webpack_public_path__ + "static/media/brand_09.b910f53d.png";